import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect } from 'react-router-dom';

import Toggle from 'react-toggle';
import Select from 'react-select';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';

class FatigueAdd extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      types_list: [],
      applicabilities_list: [],
      automation_types_list: [],
      automatic_field: 0,
      operators_list: [],
      operator: '',
      applicability: '',
      type: '',
      name: '',
      hour_points: '',
      quantity_points: '',
      point_limit: '',
      limit_extra_hours_week: '',
      limit_extra_hours_month: '',
      day_limit_extra_hours_week: '',
      day_limit_extra_hours_month: '',      
      max_points: null,
      nocturnal_extra_points: null,
      min_points: null,
      required: 0,
      extra_hours: 0,
      aps_day: 0,
      hours_day: 0,
      hours_off: 0,
      applicability_id: 1,
    };

    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.locale = getLocale();

    this.add = this.add.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleSelectChangeMulti(name, event) {
    var change = {};
    var change2 = {};
    if(event == null) {
      change['applicability_name'] = null;
      change2['applicability_id'] = null;
    } else {
      change['applicability_name'] = event.label;
      change2['applicability_id'] = event.value;
    }
    this.setState(change);
    this.setState(change2);
  }

  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  } 
  
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/parametros-de-fadiga/listagens';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({types_list: responseJson.data.types});
          self.setState({operators_list: responseJson.data.operators});
          self.setState({applicabilities_list: responseJson.data.applicabilities});
          self.setState({automation_types_list: responseJson.data.automation_types});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      }); /* Overlay */
    });
  }

  add(event) {
    event.preventDefault();
    var datasave = {
      operator: this.state.operator,
      applicability_name: this.state.applicability_name,
      applicability_id: this.state.applicability_id,
      automation_type_id: this.state.automation_type_id,
      automatic_field: this.state.automatic_field,
      type: this.state.type,
      name: this.state.name,
      hour_points: this.state.hour_points,
      quantity_points: this.state.quantity_points,
      point_limit: this.state.point_limit,
      max_points: this.state.max_points,
      nocturnal_extra_points: this.state.nocturnal_extra_points,
      min_points: this.state.min_points,
      required: this.state.required,
      extra_hours: this.state.extra_hours,
      aps_day: this.state.aps_day,
      hours_day: this.state.hours_day,
      hours_off: this.state.hours_off,
      reduction_points: this.state.reduction_points,
      limit_extra_hours_week: this.state.limit_extra_hours_week,
      limit_extra_hours_month: this.state.limit_extra_hours_month,
      day_limit_extra_hours_week: this.state.day_limit_extra_hours_week,
      day_limit_extra_hours_month: this.state.day_limit_extra_hours_month,      
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/parametro-de-fadiga', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var url = '/parametro-de-fadiga/editar/' + responseJson.data.id;
          var storage = {
            alert_message: responseJson.message,
            alert_type: responseJson.status,
          };
          localStorage.setItem("verify_message", JSON.stringify(storage));
          self.setState({redirect_url: url});
        }
        self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    return (
<div>
  <Topo promptInstall={this.props.promptInstall}></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container-liquid">
    <div className="conteudo">
    
      <h3 className="page-title pull-left">{this.locale.Fadigas.AdicionarFadiga.titulo}</h3>
      <Link to="/parametros-de-fadiga" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.add}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Fadigas.AdicionarFadiga.formulario.Nome}:</label>
              <input type="text" name="name" className="form-control" placeholder={this.locale.Fadigas.AdicionarFadiga.formulario.placeholder.NomeDoParametroDeFadiga} value={this.state.name} onChange={this.handleChange.bind(this, 'name')} required />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Fadigas.AdicionarFadiga.formulario.Tipo}:</label>
              <Select
                className="form-field-name"
                name="type"
                value={this.state.type}
                searchable={true}
                placeholder={this.locale.Fadigas.AdicionarFadiga.formulario.placeholder.SelecionarTipo}
                onChange={this.handleSelectChange.bind(this, 'type')}
                options={this.state.types_list}
                required
              />
            </div>
          </div>
        </div>


        {(this.state.type !== 'text') ?
          <div>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>{this.locale.Fadigas.AdicionarFadiga.formulario.Operador}:</label>
                  <Select
                    className="form-field-name"
                    name="operator"
                    value={this.state.operator}
                    searchable={true}
                    placeholder={this.locale.Fadigas.AdicionarFadiga.formulario.placeholder.SelecionarOperador}
                    onChange={this.handleSelectChange.bind(this, 'operator')}
                    options={this.state.operators_list}
                    required
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>{this.locale.Fadigas.AdicionarFadiga.formulario.PontosPorHora}:</label>
                  <input type="text" name="hour_points" className="form-control" placeholder={this.locale.Fadigas.AdicionarFadiga.formulario.placeholder.QuantidadeDePontosPorHora} value={this.state.hour_points} onChange={this.handleChange.bind(this, 'hour_points')} />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>{this.locale.Fadigas.AdicionarFadiga.formulario.PontosPorQuantidade}:</label>
                  <input type="text" name="quantity_points" className="form-control" placeholder={this.locale.Fadigas.AdicionarFadiga.formulario.placeholder.QuantidadeDePontosPorQuantidade} value={this.state.quantity_points} onChange={this.handleChange.bind(this, 'quantity_points')} />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>{this.locale.Fadigas.AdicionarFadiga.formulario.LimiteDePontos}:</label>
                  <input type="text" name="point_limit" className="form-control" placeholder={this.locale.Fadigas.AdicionarFadiga.formulario.placeholder.LimiteDePontosDoParametro} value={this.state.point_limit} onChange={this.handleChange.bind(this, 'point_limit')} />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>{this.locale.Fadigas.AdicionarFadiga.formulario.PontuacaoExtraPorHoraNoturna}:</label>
                  <input type="text" name="nocturnal_extra_points" className="form-control" placeholder={this.locale.Fadigas.AdicionarFadiga.formulario.placeholder.PontuacaoExtraPorHoraNoturna} value={this.state.nocturnal_extra_points} onChange={this.handleChange.bind(this, 'nocturnal_extra_points')} />
                </div>
              </div>
            </div>
          </div>    
          : ''
        }
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Fadigas.AdicionarFadiga.formulario.AplicabilidadeTipoDeColaborador}:</label>
              <Select
                className="form-field-name"
                name="applicability_id"
                value={this.state.applicability_id}
                searchable={true}
                required
                placeholder={this.locale.Fadigas.AdicionarFadiga.formulario.placeholder.SelecionarAplicabilidade}
                onChange={this.handleSelectChangeMulti.bind(this, 'applicability_id')}
                options={this.state.applicabilities_list}
              />
            </div>
          </div>
          {this.state.applicability_id == 1 || this.state.type == 'text' ? 
            '' :
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.Fadigas.AdicionarFadiga.formulario.PontosAReduzirParaTreinamento}:</label>
                <input type="text" name="reduction_points" className="form-control" placeholder={this.locale.Fadigas.AdicionarFadiga.formulario.placeholder.PontosAReduzirParaTreinamento} value={this.state.reduction_points} onChange={this.handleChange.bind(this, 'reduction_points')} />
              </div>
            </div>
          }
        </div>



        <div className="row">
          <div className="col-md-3">
            <div className="form-group">
              <label>{this.locale.Fadigas.AdicionarFadiga.formulario.ParametroObrigatorio}?</label>
              <br/>
              <Toggle
                checked={this.state.required}
                aria-label='No label tag'
                name="required"
                onChange={this.handleToggleChange.bind(this, 'required')} />
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>{this.locale.Fadigas.AdicionarFadiga.formulario.ParametroAutomatico}?</label>
              <br/>
              <Toggle
                checked={this.state.automatic_field}
                aria-label='No label tag'
                name="automatic_field"
                onChange={this.handleToggleChange.bind(this, 'automatic_field')} />
            </div>
          </div>
          {(this.state.automatic_field === 1) ?
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.Fadigas.AdicionarFadiga.formulario.TipoDeAutomacao}:</label>
                <Select
                  className="form-field-name"
                  name="automation_type"
                  value={this.state.automation_type_id}
                  searchable={true}
                  placeholder={this.locale.Fadigas.AdicionarFadiga.formulario.placeholder.SelecionarTipo}
                  onChange={this.handleSelectChange.bind(this, 'automation_type_id')}
                  options={this.state.automation_types_list}
                />
              </div>
            </div>
            : ''
          }
        </div>
        {(this.state.type !== 'text') ?
          <div>
            <hr/>
            <h4>{this.locale.Fadigas.AdicionarFadiga.formulario.tituloAlertas}</h4>
            <hr/>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>{this.locale.Fadigas.AdicionarFadiga.formulario.LimiteMaximoDePontos}:</label>
                  <input type="text" name="max_points" className="form-control" placeholder={this.locale.Fadigas.AdicionarFadiga.formulario.placeholder.LimiteMaximoDePontos} value={this.state.max_points} onChange={this.handleChange.bind(this, 'max_points')} />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>{this.locale.Fadigas.AdicionarFadiga.formulario.LimiteMinimoDePontos}:</label>
                  <input type="text" name="min_points" className="form-control" placeholder={this.locale.Fadigas.AdicionarFadiga.formulario.placeholder.LimiteMinimoDePontos} value={this.state.min_points} onChange={this.handleChange.bind(this, 'min_points')} />
                </div>
              </div>
            </div>
          </div>
          : ''
        }        
        {(this.state.automation_type === 'extra_hours' && this.state.api_type === 'rubi') ?
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.Fadigas.AdicionarFadiga.formulario.LimiteDePontosDeHoraExtraPorSemana}:</label>
                <input type="number" name="limit_extra_hours_week" className="form-control" placeholder="" value={this.state.limit_extra_hours_week} onChange={this.handleChange.bind(this, 'limit_extra_hours_week')} />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.Fadigas.AdicionarFadiga.formulario.LimiteDePontosDeHoraExtraPorMes}:</label>
                <input type="number" name="limit_extra_hours_month" className="form-control" placeholder="" value={this.state.limit_extra_hours_month} onChange={this.handleChange.bind(this, 'limit_extra_hours_month')} />
              </div>
            </div>
          </div>
          : ''
        }

        {(this.state.automation_type === 'extra_hours' && this.state.api_type === 'rubi') ?
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.Fadigas.AdicionarFadiga.formulario.LimiteDeDiasComHoraExtraPorSemana}:</label>
                <input type="number" name="day_limit_extra_hours_week" className="form-control" placeholder="" value={this.state.day_limit_extra_hours_week} onChange={this.handleChange.bind(this, 'day_limit_extra_hours_week')} />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.Fadigas.AdicionarFadiga.formulario.LimiteDeDiasComHoraExtraPorMes}:</label>
                <input type="number" name="day_limit_extra_hours_month" className="form-control" placeholder="" value={this.state.day_limit_extra_hours_month} onChange={this.handleChange.bind(this, 'day_limit_extra_hours_month')} />
              </div>
            </div>
          </div>        
          : ''
        }

        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Fadigas.AdicionarFadiga.formulario.botaoAdicionarParametroDeFadiga}</button>
          </div>
        </div>        
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default FatigueAdd;



// WEBPACK FOOTER //
// ./src/Components/Fatigue/FatigueAdd.js